import React, { useState } from "react";
import InputField from "../InputField";
import SubmitButton from "../SubmitButton";

export default function AdminUserRegisterForm({ onSubmit, isLoading }) {

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [localError, setLocalError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLocalError("");

    if (!fullName.trim()) {
      setLocalError("لطفاً نام و نام خانوادگی را وارد کنید.");
      return;
    }

    if (
      !phoneNumber ||
      phoneNumber.length !== 11 ||
      !phoneNumber.startsWith("09")
    ) {
      setLocalError("لطفاً یک شماره موبایل معتبر وارد کنید.");
      return;
    }

    try {
      await onSubmit({
        fullName,
        phoneNumber,
      });
    } catch (err) {
      setLocalError(
        err.response?.data?.detail ||
        "ایجاد کاربر ناموفق بود."
      );
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">

      {/* نام */}
      <InputField
        label="نام و نام خانوادگی"
        name="fullName"
        type="text"
        placeholder="نام کامل کاربر"
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
      />

      {/* شماره موبایل */}
      <div className="flex flex-col gap-1.5">

        <label className="text-sm font-medium text-gray-700">
          شماره موبایل
        </label>

        <input
          type="text"
          placeholder="09123456789"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          dir="ltr"
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
        />

      </div>

      {localError && (
        <p className="text-red-600 text-sm pr-1">
          {localError}
        </p>
      )}

      <SubmitButton
        text={isLoading ? "در حال ثبت..." : "ایجاد کاربر"}
      />

    </form>
  );
}
